// 업무 결과 판정 헬퍼 (설계 §7.1): 성공 n건·실패 m건 → result
export function resultOf(success: number, failed: number): 'success' | 'partial' | 'fail' {
  if (success > 0 && failed === 0) return 'success'
  if (success > 0) return 'partial'
  return 'fail'
}

// 서버 오류 코드 추출 — admin-api 계열 error.code / adminapi meta.code, 없으면 unknown
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorCodeOf(err: any): string {
  try {
    const data = err && err.response ? err.response.data : null
    const code = data && data.error && data.error.code !== undefined ? data.error.code : data && data.meta ? data.meta.code : undefined
    return code === undefined || code === null ? 'unknown' : String(code)
  } catch (e) {
    return 'unknown'
  }
}
